import { EventName } from '@/shared/types/segment';

import { toErrorReason } from './errorReason';
import { trackEvent } from './segment';

/** The dimensions both halves of the launch outcome are sliced by. */
type LaunchContext = { campaign_id?: string; campaign_type: string; is_scheduled: boolean };

/**
 * The launch outcome pair, for the two review screens that submit by hand rather
 * than through one mutation, so the mutation cache from `createMutationCache()`
 * never sees them. Both halves live here so the verb and the properties cannot
 * drift apart.
 */
export const trackCampaignLaunched = (context: LaunchContext) =>
  trackEvent(EventName.CampaignLaunched, context);

export const trackCampaignLaunchFailed = (error: unknown, context: LaunchContext) =>
  trackEvent(EventName.ActionFailed, {
    ...context,
    action: 'campaign_launch',
    error_reason: toErrorReason(error),
  });
